<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="flex flex-wrap items-center mt-5">
                <div class="flex-grow vx-row">
                    <div class="vx-col ">
                        <vs-button
                            class="float-left mr-4 mb-2"
                            @click="addCustomer"
                            color="primary"
                            type="border"
                            icon-pack="feather"
                            icon="icon-settings">
                            {{$t('menuCustomer.addCustomer')}}
                        </vs-button>
                    </div>
                    <div class="vx-col ">
                        <vs-button icon="icon-rotate-cw" icon-pack="feather"
                                   type="border" class="mb-2"
                                   @click="UpdateModelFaceBank">{{$t('button.updateAI')}}
                        </vs-button>
                    </div>
                </div>

                <!-- ITEMS PER PAGE -->
                <Pagination
                    class="mb-2"
                    :itemList="customerData"
                    :currentPage="currentPage"
                    :paginationPageSize="paginationPageSize"
                    :gridApi="gridApi"
                />

                <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full mt-4 mb-2 sm:order-normal order-3 sm:mt-0 "
                          v-model="searchQuery"
                          @input="updateSearchQuery" :placeholder="$t('button.search')"/>
            </div>
            <!-- AgGrid Table -->
            <ag-grid-vue style="height: 55vh"
                         ref="agGridTable"
                         :components="components"
                         :gridOptions="gridOptions"
                         class="ag-theme-material w-100 my-4 ag-grid-table"
                         :columnDefs="columnDefs"
                         :defaultColDef="defaultColDef"
                         :rowData="customerData"
                         :animateRows="true"
                         :pagination="true"
                         :localeText="{noRowsToShow: this.$t('menuCustomer.noRowsToShow')}"
                         :paginationPageSize="paginationPageSize"
                         :onGridReady="onGridReady"
                         :suppressPaginationPanel="true">
            </ag-grid-vue>

            <vs-pagination
                :total="totalPages"
                :max="maxPageNumbers"
                v-model="currentPage"/>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import {AgGridVue} from "ag-grid-vue"
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import CellRendererActions from "./cell-renderer/CellRendererActions.vue"
import moment from "moment";
import Pagination from "../../ui-elements/Pagination.vue"

export default {
    components: {
        AgGridVue,
        vSelect,
        // Cell Renderer
        CellRendererActions,
        Pagination
    },
    data() {
        return {
            searchQuery: "",
            maxPageNumbers: 7,
            // AgGrid
            gridApi: null,
            gridOptions: {},
            defaultColDef: {},
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.customerCode'),
                    field: 'customerCode',
                    width: 200
                },
                {
                    headerName: this.$t('menuCustomer.customerName'),
                    field: 'fullName',
                    width: 200
                },
                {
                    headerName: this.$t('menuCustomer.phoneNumber'),
                    field: 'phone',
                    width: 200,
                }, {
                    headerName:  this.$t('menuCustomer.dateCreated'),
                    field: 'created_at_display',
                    width: 200,
                },
                {
                    headerName: this.$t('button.actions'),
                    field: 'actions',
                    width: 120,
                    cellRendererFramework: 'CellRendererActions',
                },
            ],
            // Cell Renderer Components
            components: {
                CellRendererActions,
            },
            customerData: [],
        }
    },
    created() {
        this.initScreen()
    },
    watch: {
        '$store.state.windowWidth'(val) {
            if (val <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
        '$store.state.isUpdateVipCustomer'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_VIP_CUSTOMER', false);
            }
        }
    },
    computed: {
        paginationPageSize() {
            if (this.gridApi) return this.gridApi.paginationGetPageSize();
            else return 20
        },
        totalPages() {
            if (this.gridApi) return this.gridApi.paginationGetTotalPages();
            else return 0
        },
        currentPage: {
            get() {
                if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
                else return 1
            },
            set(val) {
                this.gridApi.paginationGoToPage(val - 1)
            }
        },
    },
    methods: {
        updateSearchQuery(val) {
            this.gridApi.setGridOption('quickFilterText', val);
        },
        addCustomer() {
            this.$router.push(`/user/add-customer`).catch(() => {
            });
        },
        onGridReady() {
            if (this.$store.state.windowWidth <= 1024) {
                this.maxPageNumbers = 5;
            } else {
                this.maxPageNumbers = 7;
            }

            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        initScreen() {
            this.$vs.loading();
            this.$crm.get('/customer/find-all').then((response) => {
                this.customerData = response.data.map(item => {
                    let createdDate = moment(item.createdDate).format('DD/MM/YYYY HH:mm:ss')
                    return {
                        customerCode: item.customerCode,
                        fullName: item.fullName,
                        phone: item.phone,
                        created_at_display: createdDate,
                        id: item.id
                    };
                });
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Có lỗi sảy ra!',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
        UpdateModelFaceBank() {
            this.$vs.loading();
            this.$crm.get('/face-bank-model/version/update').then(() => {
                this.$vs.loading.close();
                setTimeout(() => {
                    if (this.$store.state.windowWidth > 1024) {
                        this.gridApi.sizeColumnsToFit();
                    }
                }, 100);
                return this.$vs.notify({
                    text: 'Cập nhật dữ liệu thành công',
                    iconPack: 'feather',
                    icon: 'icon-CheckCircleIcon',
                    color: 'success'
                });
            }).catch(() => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: 'Đã có lỗi xảy ra',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },
    },
    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
